import React from 'react';
import { Power } from 'lucide-react';
import { text } from '../constants/configurationText';

const CompanyStatusToggle = ({ theme, permissions, styles, t = text.en, onToggle }) => {
  return (
    <div style={styles.subCard}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
        <div style={styles.subCardTitleRow}>
          <span
            style={{
              ...styles.subCardIcon,
              ...(permissions.isActive ? null : { background: 'rgba(239,68,68,0.12)', color: '#ef4444' }),
            }}
          >
            <Power size={18} />
          </span>
          <div>
            <h4 style={styles.subCardTitle}>{t.companyStatus}</h4>
            <p style={styles.subCardSubtitle}>
              {permissions.isActive ? t.companyActive : t.companyInactive}
            </p>
          </div>
        </div>
        <div style={styles.toggle(permissions.isActive)} onClick={() => onToggle('isActive')}>
          <div style={styles.toggleKnob(permissions.isActive)} />
        </div>
      </div>
    </div>
  );
};

export default CompanyStatusToggle;
